// extracted by css-extract-rspack-plugin
export default {"divisionSelectorWrapper":"division-selector-wrapper--yVLyj_MsSyoImu8C"};